import easing from 'jquery.easing';

export class App{
  constructor(){
    this.btn_judge = false;
    this.win = $(window);
    this.html = $('html,body');
    this._html = document.documentElement;
    this._body = document.body;
    this.body = $('body');
    this.page = $('#page');
    this.site_header = $('.site-header');
    this.winH = window.innerHeight;
    this.winW = window.innerWidth;
    this.headerH = this.site_header.outerHeight();
    this.footer = $('.site-footer');
    this.footerTop = this.footer.offset().top;
    this.btn_top = $('.btn_top');
    this.res_timer = false;
    this.anm_time = 700;
    this.anm_ease = "easeInOutExpo";
    this.anm_delay = 1500;
    this.nav_judge = false;
    this.ajax_loaded = false;
    this.font_loaded = false;
  }
  init(){
    const hostname = location.hostname;
    let ajax_url;
    //console.log(hostname);
    if(hostname.match(/dev$|dev\.|stg\.|tp\./)){
      ajax_url = "https://stg.typeproject.com/wp/wp-admin/admin-ajax.php";
    }else{
      ajax_url = "/wp/wp-admin/admin-ajax.php";
    }
    // console.log(ajax_url)

    //console.log(locale);

    // $.ajax({
    //   type:'POST',
    //   //url:"http://dev.typeproject4/wp/wp-admin/admin-ajax.php",
    //   url:ajax_url,
    //   data: {
    //     'action': 'my_ajax',
    //     'type':'wp',
    //     'site_type':'stf_blog',
    //     'lng':locale//'en_US'
    //   },
    //   success: (responce)=>{
    //     this.ajax_loaded = true;
    //     //console.log('WWWWW' + responce);
    //     // const res = document.getElementById('result');
    //     // res.innerHTML = responce;

       



    //     // this.next();


    //     // this.events();
    //   }
    // });


    this.main = document.getElementById('primary');
    if(!document.body.classList.contains('glossary')){
      let all_txt = "ブログ一覧";
      if(locale === 'en_US'){
        all_txt = "Blog All";
      }
      this.p_header = document.createElement('div');
      this.p_header.classList.add('page_fix_header');
      this.p_header_inner = document.createElement('div');
      this.p_header_inner.classList.add('page_fix_header_inner');
      this.p_header_inner.innerHTML = '<div class="btn_wrap"><a id="btn_sp_nav" href="'+home_url+'">'+all_txt+'</a></div>';
      this.p_header.appendChild(this.p_header_inner);
      this.main.insertBefore(this.p_header, this.main.firstElementChild);
      if(document.querySelector('.btn_maga')){
        this.maga = document.querySelector('.btn_maga').cloneNode(true);
        this.p_header_inner.querySelector('.btn_wrap').insertBefore(this.maga, this.p_header_inner.querySelector('.btn_wrap').firstElementChild);
      }

    }else{

      this.p_header = document.querySelector('.page_fix_header');
      this.p_header_inner = document.querySelector('.page_fix_header_inner');
    }


    this.btn_nav = $('.btn_nav');
    this.site_header = $('.site-header');
    this.btn_nav_inner = $('.btn_nav_inner');
    this.btn_nav_ser = $('.sr_ttl');
    this.btn_nav_font = $('.font_ttl');
    this.nav_container = $('.nav_container');
    this.site_branding = $('.site-branding');
    this.lg_list = $('.lg_list');
    this.site_branding.after(this.lg_list);
    this.side = document.getElementById('secondary');
    this.secWidget = document.getElementById('sec-widget');
    this.back = document.createElement('div');
    this.back.classList.add('back');
    //console.log(this.side);
    this.side.parentNode.insertBefore(this.back,this.side);
    this.btn_sp_nav = document.getElementById('btn_sp_nav');
    this.btn_close = document.createElement('div');
    this.btn_close.classList.add('btn_close');
    this.side.appendChild(this.btn_close);







    //header
    const hmMenuContainer = document.querySelector('.hmMenuContainer')
    const btn_hm = document.getElementById('btn_hm')
    const menu_back = document.querySelector('.hmMenuContainer-back')
    // console.log(btn_hm)
    let btn_state = false;

    btn_hm.addEventListener('click', (e) => {
      btn_state = !btn_state
      changeBtn()
    })
    menu_back.addEventListener('click', () => {
      btn_state= false
      changeBtn()
    })

    const changeBtn = () => {
      if(btn_state){
        btn_hm.classList.remove('off')
        btn_hm.classList.add('on')
        hmMenuContainer.classList.add('on')
      }else{
        btn_hm.classList.remove('on')
        btn_hm.classList.add('off')
        hmMenuContainer.classList.remove('on')
      }
    }









    const obj = RT.start(
      (e)=>{
        console.log('error');
        
      },
      ()=>{
        this.font_loaded=true;
        console.log('fonts loaded');
        
        // this.next();
        
        // this.events();
      }
    );

    this.next();
        
    this.events();

    //console.log(RT);
    

  }
  next(){
    // console.log(this.ajax_loaded,this.font_loaded);
    //if(this.ajax_loaded && this.font_loaded){

      setTimeout(()=>{
        this.page[0].classList.add('on');
        $('.spinner').fadeOut('slow',function(){
          $(this).remove();
        });
      },1000);

    //}

  }
  events(){
    //console.log('events');
    const _this = this;

    const _links = document.querySelectorAll('#content a[href^="#"]');
    for(const _a of _links){
      _a.addEventListener('click',(e)=>{
        e.preventDefault();
        let href = e.currentTarget.getAttribute('href');
        href = href.replace("#","");
        if(!href){return false;}



        const target = document.getElementById(href);
        const tarRect = target.getBoundingClientRect();

          // if(window.matchMedia("(max-width:768px)").matches){
          //
          // }

          //console.log(this.scT,this.headerH);

          let pos = tarRect.top + this.scT - this.headerH;

          //if(e.currentTarget.classList.contains('w_nav')){
          if(document.body.classList.contains('glossary')){
            //pos -= this.p_header_innerH;
          }
          this.html.animate({
            scrollTop:pos
          },this.anm_time,this.anm_ease);

          if(this.state === "sp"){
            this.side_close();
          }

      });
    }

    this.btn_sp_nav.addEventListener('click',(e)=>{
      e.preventDefault();
      if(this.side.classList.contains('on')){
        this.side_close();
      }else{
        this.side_open();
      }
    });
    this.back.addEventListener('click',(e)=>{
      if(this.nav_judge){
        this.side_close();
      }
    });
    this.btn_close.addEventListener('click',(e)=>{
      if(this.nav_judge){
        this.side_close();
      }
    });

    window.matchMedia("(min-width:769px)").addListener(()=>{
      if(window.matchMedia("(max-width:768px)").matches){
        this.secWidget.classList.remove('on');
        this.secWidget.style.top = "";
        //console.log('match');
      }
    });

    if(document.body.classList.contains('glossary')){

      //this.side = document.getElementById('secondary');
      //this.secWidget = document.getElementById('sec-widget');
      this.catList = this.secWidget.querySelector('.cat-list');
      this.secWidget_ttl = this.secWidget.querySelector('.widget-title');
      this.word_link = this.secWidget.querySelectorAll('a');



      this.secWidgets_ttlH = 0;
      this.p_header_innerH = 0;

      // for(const _a of this.word_link){
      //   _a.addEventListener('click',(e)=>{
      //     e.preventDefault();
      //     let href = e.currentTarget.getAttribute('href');
      //     href = href.replace("#","");
      //
      //     const target = document.getElementById(href);
      //     const tarRect = target.getBoundingClientRect();
      //
      //     this.html.animate({
      //       scrollTop:tarRect.top + this.scT - this.headerH
      //     },this.anm_time,this.anm_ease);
      //   });
      // }

      if(ua !== "mobile"){
        this.onScroll();
        // window.matchMedia("(min-width:769px)").addListener(()=>{
        //   if(window.matchMedia("(max-width:768px)").matches){
        //     this.secWidget.classList.remove('on');
        //     this.secWidget.style.top = "";
        //     //console.log('match');
        //   }
        // });
      }



    }else{
      const side = document.getElementById('categories-2');
      const cat_ul = side.querySelectorAll('#categories-2 .children');
      const cat_ul_pa = document.querySelector('#categories-2 > ul');
      const cat_list = side.querySelectorAll('#categories-2 > ul > .cat-item > a');
      cat_ul_pa.classList.add('parent');
      for(const ch_ul of cat_ul){
        ch_ul.outerHTML = `<div class="chi_wrap">${ch_ul.outerHTML}</div>`;
        //console.log(ch_ul);
      }


      for(const _list of cat_list){
        _list.addEventListener('click',(e)=>{
          e.preventDefault();
          const _cur = e.currentTarget;
          //const li_h = e.currentTarget.nextElementSibling.querySelector('li').offsetHeight;
          const _w = e.currentTarget.nextElementSibling;
          const _ch = _w.querySelector('.children');

          if(_cur.classList.contains('on')){
            _cur.classList.remove('on');
            _w.style.maxHeight = 0;
          }else{
            _cur.classList.add('on');
            _w.style.maxHeight = _ch.offsetHeight+"px";
          }

          //$(e.currentTarget.nextElementSibling).slideToggle('slow');
        })
      }
    }




    if(ua == "mobile"){
      //$('.nav_container').meanmenu();
      $('.nav_list_container_sp .list .nav_ttl').on('click',function(e){
        //console.log('nav_click');
        $(this).next('ul').slideToggle('slow');
      });
    }

    this.win.on({
      'resize load':function(e){
        _this.onResize(e);
      },
      'scroll load':function(e){
        _this.onScroll(e);
      }
    });
    this.win.trigger('resize');
    this.win.trigger('scroll');

    const mediaQuery = window.matchMedia("(max-width:768px)");

    const listener = (e) => {
      if(e.matches){
        this.state = "sp";
        //console.log('to sp');
      }else{
        this.state = "pc";
        if(this.nav_judge){
          this.side_close();
        }
        //console.log('to pc');
      }
    }
    mediaQuery.addListener(listener);
    listener(mediaQuery);


    this.btn_nav.on('click',(e) => {
      console.log('click');
      this.btn_judge = !this.btn_judge;
      this.move_menu(e);

    });

    this.btn_nav_inner.on('click',(e) => {
      this.close_event();
    });

    this.btn_nav_font.on('click',(e) => {
      this.sub_op.call(this,$(e.currentTarget));
      this.btn_nav_ser.parent('.list').removeClass('on');
    });

    this.btn_nav_ser.on('click',(e) => {
        this.sub_op.call(this,$(e.currentTarget));
        this.btn_nav_font.parent('.list').removeClass('on');
    });

    this.btn_top.on('click',(e)=>{
        this.html.animate({
          scrollTop:0
        },this.anm_time,this.anm_ease);
      });

  }
  side_close(){
    //console.log('side close');
    this.nav_judge = false;
    this.side.classList.remove('on');
    this.back.classList.remove('on');
    setTimeout(()=>{
      this.win.trigger('scroll');
    },100);
  }
  side_open(){
    this.nav_judge = true;
    this.side.classList.add('on');
    this.back.classList.add('on');
  }
  sub_op(obj){
    const _this = this;
    const that = obj;
    //console.log(that);
    that.parent('.list').siblings('.list').removeClass('on').end().toggleClass('on');
    if(that.parent('.list').hasClass('on')){
        _this.btn_nav_inner.addClass('on');
    }else{
        _this.btn_nav_inner.removeClass('on');
    }
  }
  move_menu(){
    console.log('move menu');
    if(this.btn_judge){
      this.site_header.addClass('on');
      // this.content.css({
      //   paddingTop:this.navH - this.headerH
      // });
    }else{
      this.site_header.removeClass('on');
      this.close_event();
      // this.content.css({
      //   paddingTop:0
      // });
    }
  }
  close_event(){
    this.btn_nav_font.parent('.list').removeClass('on');
    this.btn_nav_ser.parent('.list').removeClass('on');
    this.btn_nav_inner.removeClass('on');
  }
  onResize(){
    const _this = this;
    this.getSize();
    this.setSize();
    if(this.res_timer !== false){
      clearTimeout(this.res_timer);
    }
    this.res_timer = setTimeout(function(){
      _this.getSize();
      _this.setSize();
      //console.log('last resize');
      setTimeout(function(){
        _this.getSize();
        _this.setSize();
        //console.log('more resize');
      },1000);
    },200);
  }
  onScroll(){
    this.scT = this.win.scrollTop();
    if((this.scT+this.winH) > (this.footerTop+30)){
        this.footer.addClass('on');
      }else{
        this.footer.removeClass('on');
      }
    //if(document.body.classList.contains('glossary')){
      //if(ua !== "mobile"){
        //if(this.winW > 768){
          this.sideRect = this.p_header.getBoundingClientRect();
          if(this.headerH >= this.sideRect.top){
            if(this.winW > 768){
              this.secWidget.classList.add('on');
              // this.secWidget.style.top = this.headerH+"px";
            }

            this.p_header.classList.add('on');
            this.p_header_inner.style.top = this.headerH+"px";
          }else{
            if(this.winW > 768){
              this.secWidget.classList.remove('on');
              // this.secWidget.style.top = "";
            }

            this.p_header.classList.remove('on');
            this.p_header_inner.style.top = "";
          }
        // }else{
        //   // this.secWidget.classList.remove('on');
        //   // this.secWidget.style.top = "";
        // }
      //}


    //}
  }
  setSize(){
    this.nav_container.css({
      maxHeight:this.winH-this.headerH,
      marginTop:this.headerH
    });
    this.page.css({
      paddingTop:this.headerH
    });
    if(this.secWidget && this.catList){
      //console.log(this.secWidget);
      this.catList.style.maxHeight = this.winH - (this.headerH + this.footerH + this.secWidgets_ttlH ) + "px";
    }

    if(window.matchMedia("(max-width:768px)").matches){
      // this.side.style.top = this.headerH+"px";
    }else{
      // this.side.style.top = "";
    }

    this._html.style.setProperty('--hh',this.headerH+"px");

    // if(window.matchMedia("(max-width:768px)").matches){
    //
    // }
  }
  getSize(){
    this.winH = window.innerHeight;
    this.winW = window.innerWidth;
    this.headerH = this.site_header.outerHeight();
    this.navH = this.nav_container.outerHeight();
    this.footerH = this.footer.outerHeight();
    this.footerTop = this.footer.offset().top;
    this.scT = this.win.scrollTop();
    if(this.secWidget_ttl){
      this.secWidgets_ttlH = this.secWidget_ttl.offsetHeight;
      this.p_header_innerH = this.p_header_inner.offsetHeight;
      //console.log(this.secWidgets_ttlH);
    }
  }
}
